import useRouter from './useRouter'

/**
 * Return the route params from the url
 */
export default function useRouteParams() {
  const { match: { params } = {} } = useRouter()
  return params
}
